// Texty klientskej sekcie — slovenské dvojča locale/cs/customerPage.js.
// SK: klientská sekcia nemá fixtures (bez prihlásenia) — terminológia je
// odvodená z dev/sk/login.html, register.html a bežnej slovenčiny Shoptetu.
import { plural } from '../plural.js';

export default {
  // Skupiny sidebaru (GROUPS)
  groupAccount: 'Účet',
  groupPurchases: 'Nákupy',
  groupDocs: 'Doklady',
  groupBenefits: 'Výhody a obsah',

  // Zkrácené popisky mobilních pilulek/dlaždic (NAV[].short)
  navHub: 'Prehľad',
  navSettings: 'Osobné údaje',
  navShipping: 'Doručovacia adresa',
  navOrders: 'Objednávky',
  navDocs: 'Daňové doklady',
  navProforma: 'Zálohové faktúry',
  navCredit: 'Dobropisy',
  navDelivery: 'Dodacie listy',
  navPayments: 'Doklady k platbe',
  navDiscounts: 'Zľavy',
  navReviews: 'Hodnotenia',
  navThreads: 'Diskusia',

  // Druhý řádek dlaždice rozcestníku (TILE_DESC)
  tileSettings: 'Kontakt, fakturačná adresa a heslo.',
  tileShipping: 'Adresa, kam vám doručíme tovar.',
  tileOrders: 'Stav zásielky, história a opätovný nákup.',
  tileDocs: 'Faktúry k dokončeným objednávkam v PDF.',
  tileProforma: 'Podklady k platbe vopred.',
  tileCredit: 'Vrátený tovar a opravné doklady.',
  tileDelivery: 'Čo presne prišlo v ktorej zásielke.',
  tilePayments: 'Potvrdenie o zaplatení.',
  tileDiscounts: 'Cenová hladina a individuálne zľavy.',
  tileReviews: 'Recenzie, ktoré ste napísali.',
  tileThreads: 'Otázky k produktom a odpovede.',

  // Perex pod H1 (PEREX)
  perexHub: 'Objednávky, doklady, uložené údaje aj zľavy máte na jednom mieste. Vyberte si sekciu.',
  perexSettings:
    'Údaje sa predvypĺňajú do košíka. E-mail aj heslo meníte v rovnakom formulári, zmenu potvrdíte aktuálnym heslom.',
  perexShipping: 'Adresa, na ktorú vám doručíme tovar. Fakturačné údaje sa menia v osobných údajoch.',
  perexOrders: 'História nákupov vrátane stavu zásielky, dokladov a možnosti objednať to isté znova.',
  perexDocs: 'Faktúry k dokončeným objednávkam. Doklad si môžete kedykoľvek stiahnuť v PDF.',
  perexProforma: 'Podklady k platbe vopred. Po zaplatení dostanete bežný daňový doklad.',
  perexCredit: 'Opravné doklady k vrátenému alebo reklamovanému tovaru.',
  perexDelivery: 'Čo presne prišlo v ktorej zásielke.',
  perexPayments: 'Potvrdenie o prijatej platbe k vašim objednávkam.',
  perexDiscounts: 'Zľavy sa počítajú automaticky v košíku, nemusíte zadávať žiadny kód.',
  perexReviews: 'Hodnotenia, ktoré ste napísali. Zverejnené uvidia ostatní zákazníci pri produkte.',
  perexThreads: 'Otázky k produktom a odpovede nášho tímu.',
  /** pozdrav před perexem rozcestníku: „Dobrý deň, Ján. …" / „Dobrý deň. …" */
  greeting: (firstName) => (firstName ? 'Dobrý deň, ' + firstName + '. ' : 'Dobrý deň. '),

  // Prázdné stavy (EMPTY)
  emptyOrdersTitle: 'Ešte ste u nás nenakúpili',
  emptyDocsTitle: 'Zatiaľ tu nie je žiadny doklad',
  emptyProformaTitle: 'Zatiaľ tu nie je žiadna zálohová faktúra',
  emptyCreditTitle: 'Zatiaľ tu nie je žiadny dobropis',
  emptyDeliveryTitle: 'Zatiaľ tu nie je žiadny dodací list',
  emptyPaymentsTitle: 'Zatiaľ tu nie je žiadny doklad k platbe',
  emptyReviewsTitle: 'Zatiaľ ste nenapísali žiadne hodnotenie',
  emptyThreadsTitle: 'Zatiaľ ste nezaložili žiadnu diskusiu',
  /** CTA prázdného stavu (výchozí i EMPTY.orders.cta — stejné znění) */
  emptyCta: 'Prezrieť ponuku',

  // Zkratky pod prázdným stavem (SHORTCUTS)
  shortcutSale: 'Akciová ponuka',
  shortcutClearance: 'Výpredaj',
  shortcutBrands: 'Značky',

  eyebrow: 'Zákaznícke centrum',
  supportTitle: 'Nesedí niečo v objednávke?',
  supportText: 'Napíšte alebo zavolajte, máme prehľad o všetkých vašich nákupoch.',
  supportTextNoPhone: 'Napíšte nám, máme prehľad o všetkých vašich nákupoch.',
  saved: 'Uložené údaje',
  edit: 'Upraviť',
  level: 'Vaša cenová hladina',
  levelCta: 'Kontaktovať obchodníka',
  b2bTitle: 'Nakupujete pravidelne na firmu?',
  b2bText: 'Veľkoobchodní odberatelia majú vlastný cenník, splatnosť na faktúru a prednostný servis náradia.',
  b2bCta: 'Podmienky B2B',
  all: 'Všetko',

  /** badge zvýhodněného ceníku v hlavičce karty: „Zvýhodnený cenník · −20 %" */
  specialDiscount: (pct) => 'Zvýhodnený cenník · −' + pct + ' %',
  specialPlain: 'Zvýhodnený cenník',

  // Karta „Uložené údaje" (buildSaved)
  mailLabel: 'Prihlasovací e-mail',
  nameLabel: 'Meno',
  shipTitle: 'Doručovacia adresa',
  shipText: 'Kam vám doručíme tovar, keď je iná ako fakturačná.',

  /** panel cenové hladiny (buildLevel), fallback bez známé úrovně VO ceníku */
  fromPricelist: 'z cenníkových cien',

  /** počet záznamů pod pilulkovým filtrem: „5 záznamov" */
  recordsCount: (n) => n + ' ' + plural(n, ['záznam', 'záznamy', 'záznamov']),

  orderSearchPlaceholder: 'Číslo objednávky',
  orderSearchAria: 'Hľadať číslo objednávky',

  /** fallback titulek karty nastavení, když sekce nemá nadpis */
  settingsFallback: 'Údaje',
  /** fallback titulek karty doručovacích údajů, když sekce nemá nadpis */
  shippingFallback: 'Doručovacia adresa',

  // --- Regexy nad NATIVNÍM textem Shoptetu (STATUS_TONE, hlavičky tabulek,
  // řádky tabulky slev). SK: neověřeno ve fixtures (klientská sekce SK bez
  // přihlášení nedostupná) — stemy odvozené ze standardní slovenštiny Shoptetu.
  toneOffRe: /zrušen|storn/i, // SK: neověřeno ve fixtures
  toneOkRe: /dokonč|vybav|doruč|zaplaten|uhraden/i, // SK: neověřeno ve fixtures
  toneShipRe: /odosl|expedov|preprav|ceste|vyzdvihnut/i, // SK: neověřeno ve fixtures
  toneWorkRe: /čaká|spracov|prijat|nová|nezaplaten|rezerv/i, // SK: neověřeno ve fixtures
  /** hlavička tabulky = sloupec s částkou (NUM_RE) */
  numRe: /čiastk|cena|celkom|dph|zľav|hodnot/i, // SK: neověřeno ve fixtures
  /** hlavička tabulky = sloupec s datem (DATE_RE) */
  dateRe: /vystaven|dátum|vytvor|splatnos|objednan/i, // SK: neověřeno ve fixtures
  /** hlavička tabulky = sloupec se stavem (STATUS_RE) */
  statusColRe: /^stav\b|status|zaplat/i, // SK: neověřeno ve fixtures
  /** řádek nativní tabulky slev: „Zákaznícka skupina" */
  discountGroupRe: /skupin/,
  /** řádek nativní tabulky slev: „Aktuálna zľava" */
  discountValueRe: /aktuáln/,
};
